import type { TableColumn } from '../TableEndpoint';

export type AdvancedFilterTableColumnDefinition<TRow> = Pick<
  TableColumn<TRow>,
  'array' | 'filter' | 'key' | 'title'
>;
